import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/rrhh')({
  component: RrhhLayout,
});

function RrhhLayout() {
  return <Outlet />;
}
